<template>
  <div class="section-parameter" v-if="infos">
    <div class="col-left">
      <h2>{{ $t('settings.contact.title') }}</h2>
    </div>
    <div class="col-right">
      <div class="form-group">
        <label>{{ $t('settings.contact.firstname') }}</label>
        <el-input type="text" v-model="infos.contact.fname"></el-input>
      </div>
      <div class="form-group">
        <label>{{ $t('settings.contact.lastname') }}</label>
        <el-input type="text" v-model="infos.contact.lname"></el-input>
      </div>
      <div class="form-group">
        <label>{{ $t('settings.contact.email') }}</label>
        <el-input type="text" v-model="infos.contact.email"></el-input>
      </div>
      <div class="form-group">
        <label>{{ $t('settings.contact.phone') }}</label>
        <el-input type="text" v-model="infos.contact.phone"></el-input>
      </div>
      <div class="form-submit">
        <el-button plain @click="save">{{ $t('settings.actions.save') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      infos: null
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite'
    })
  },
  watch: {
    site: function (site) {
      this.init()
    }
  },
  methods: {
    ...mapActions('account', ['updateSite']),
    init () {
      if (this.site) {
        this.infos = Object.assign({}, {
          id: this.site.id,
          contact: this.site.contact
        })
      }
    },
    save () {
      this.updateSite(this.infos).then(() => {
        this.$notify({title: 'Success', message: this.$root.$t('notifications.settings.edited'), type: 'success'})
      }).catch((e) => {
        this.$notify.error({ title: 'Error', message: this.$root.$t('notifications.unknown') })
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/settings/settings_contact.vue